/**
 *  Component -- Accordion script
 *  ref: https://www.w3schools.com/howto/howto_js_accordion.asp
 */
const accordion = {
  el: $('.js-accordion-trigger'),
  init() {
    this.accordionFun();
  },
  accordionFun() {
    this.el.click(function () {
      const thisEl = $(this);
      const nextEl = thisEl.next('.js-accordion-content');
      // accordion is not opened
      if (!thisEl.hasClass('js-accordion-active')) {
        thisEl.addClass('js-accordion-active');
        nextEl.slideDown('300', () => {
          if (!thisEl.hasClass('js-accordion-noScroll')) {
            nextEl.get(0).scrollIntoView({ behavior: 'smooth' });
          }
        });
      } else {
        thisEl.removeClass('js-accordion-active');
        nextEl.slideUp('300', () => {
          nextEl.attr('style', '');
        });
      }
    });
  }
};

$(document).ready(() => {
  if (accordion.el.length > 0) {
    accordion.init();
  }
});